import { render, staticRenderFns } from "./AdminRuns.vue?vue&type=template&id=0827cb6f"
import script from "./AdminRuns.vue?vue&type=script&lang=js"
export * from "./AdminRuns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports